import React, {useEffect, useState} from 'react';
import Grid from '@mui/material/Grid2';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@mui/styles';
import AppAnimate from "../../../components/AppAnimate";
import {useSnackbar} from "notistack";
import axios from "axios";
import {defaultVariables} from "../../../../config";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import MainPageSkeleton from "../../../components/loaders/MainPageSkeleton";
import Container from '@mui/material/Container';
import {useParams} from "react-router";
import {getMediaURL, scrollTop} from "../../../../config/values";
import Title from "../../../components/elements/Title";
import VendorSliderItem from "../shops/components/VendorSliderItem";
import {IconButton, Typography} from "@mui/material";
import SwiperSlider from "../../../components/elements/slider/SwiperSlider";
import {Pagination} from "@mui/lab";
import BannerSliderItem from "../components/BannerItem";
import {connect} from "trim-redux";
import {Facebook, Instagram, Linkedin, Mail, MapPinned, Phone, X, Headset} from "lucide-react";
import {WhatsApp} from "@mui/icons-material";
import BreadCrumbs from "../../../components/elements/BreadCrumbs";
import Box from '@mui/material/Box';
import Button from "@mui/material/Button";
import LoginDialog from "../components/LoginDialog";

function ContactPage({classes,setting,isAuth}){
    const { t } = useTranslation();
    const [page, setPage] = useState([]);
    const [loading, setLoading] = useState(true);
    const [fetching, setFetching] = useState(false);
    const [authOpen, setAuthOpen] = useState(false);

    const navigation = useNavigate();
    const config = {
        headers: {
            Accept: 'application/json',
        }
    }
    const { enqueueSnackbar } = useSnackbar();
    const loadData = () =>{
        setFetching(true);
        axios.get(`${defaultVariables.url}/front/page/contact`,config)
            .then(response => {
                setPage(response.data);
                setLoading(false);
                setFetching(false);
            })
            .catch(error => {
                console.error("Error fetching item data:", error);
                setLoading(false);
                setFetching(false);
            });
    }

    useEffect(() => {
        if (!fetching) {
            scrollTop();
            loadData();
        }
    },[]);
    const handleSupport = () => {
        if(!!isAuth){
            navigation('/account/support')
        }else{
            setAuthOpen(true);
        }
    }
    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={ t('contactPage')}>
            <div className="page-color-layout">
                {
                    !!loading ?
                        <Container maxWidth="xl" >
                            <MainPageSkeleton/>
                        </Container>
                        :
                        <>
                            <section className="category-page-top">
                                <Container maxWidth="xl" >
                                    <Grid container spacing={2}>
                                        <Grid item size={12}>
                                            <div className="infos">
                                                <div className="informations">
                                                    <Title component="h1" align="left" color="text" className="page-title">{ t('contactPage')}</Title>
                                                </div>
                                                <BreadCrumbs
                                                    front
                                                    singleLevel
                                                    firstText={ t('contactPage')}
                                                />
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Container>
                            </section>
                            <Container maxWidth="lg">
                                <Grid container spacing={4}>
                                    <Grid item size={{xs:12,md:7}}>
                                        <Box className={classes.contactCta}>
                                          <div className="overlay">
                                              <Title color="secondary">{ t('need-help')}</Title>
                                              <Typography>{ t('ticket-cta')}</Typography>
                                              <Button
                                                  variant="contained"
                                                  startIcon={<Headset className="lucide-large"/>}
                                                  size="large"
                                                  color="secondary"
                                                  onClick={() => handleSupport()}
                                              >
                                                  { t('ticket-submit')}
                                              </Button>
                                              <LoginDialog open={authOpen} setOpen={setAuthOpen} />
                                          </div>
                                        </Box>
                                    </Grid>
                                    <Grid item size={{xs:12,md:5}}>
                                        <Box className="card-contact">
                                            <div className="icon-holder">
                                                <Phone/>
                                            </div>
                                           <div className="contact-info">
                                               <Title component="span" color="text" >{ t('phone')}</Title>
                                               <a href={`tel:${setting.main_phone}`}>{setting.main_phone}</a>
                                           </div>
                                        </Box>
                                        <Box className="card-contact">
                                            <div className="icon-holder">
                                                <MapPinned/>
                                            </div>
                                            <div className="contact-info">
                                                <Title component="span" color="text">{ t('address')}</Title>
                                                <span className="address">{setting.main_address}</span>
                                            </div>
                                        </Box>
                                        <Box className="card-contact">
                                            <div className="icon-holder">
                                                <Mail/>
                                            </div>
                                            <div className="contact-info">
                                                <Title component="span" color="text" >{ t('email')}</Title>
                                                <a href={`mailto:${setting.main_email}`}>{setting.main_email}</a>
                                            </div>
                                        </Box>
                                        <div className="social-holder">
                                            {
                                                !!setting.instagram_url &&
                                                <IconButton component="a" target="_blank" href={setting.instagram_url}>
                                                    <Instagram className="social-icon"/>
                                                </IconButton>
                                            }
                                            {
                                                !!setting.facebook_url &&
                                                <IconButton component="a" target="_blank" href={setting.facebook_url}>
                                                    <Facebook className="social-icon"/>
                                                </IconButton>
                                            }
                                            {
                                                !!setting.x_url &&
                                                <IconButton component="a" target="_blank" href={setting.x_url}>
                                                    <X className="social-icon"/>
                                                </IconButton>
                                            }
                                            {
                                                !!setting.linkedin_url &&
                                                <IconButton  component="a" target="_blank" href={setting.linkedin_url}>
                                                    <Linkedin className="social-icon"/>
                                                </IconButton>
                                            }
                                            {
                                                !!setting.whatsapp_url &&
                                                <IconButton  component="a" target="_blank" href={setting.whatsapp_url}>
                                                    <WhatsApp className="social-icon"/>
                                                </IconButton>
                                            }
                                        </div>
                                    </Grid>


                                </Grid>
                            </Container>
                        </>

                }
            </div>
        </AppAnimate>
    );
}
const mapStateToProps = (state) => ({
    setting: state.setting,
    isAuth: state.isAuth,
});

export default withStyles(Styles)(connect(mapStateToProps)(ContactPage));
